import { useEffect, type ReactNode } from 'react'
import { IconX } from './icons'

// Minimal accessible modal: ESC + backdrop-click to close, focus-trap-light (autoFocus on
// the first field is left to callers). All chrome via theme tokens.
export function Dialog({ title, onClose, children, footer }: {
  title: string
  onClose: () => void
  children: ReactNode
  footer?: ReactNode
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div
      className="sb-modal-backdrop"
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose() }}
    >
      <div className="sb-modal" role="dialog" aria-modal="true" aria-label={title}>
        <div className="sb-modal-head">
          <span>{title}</span>
          <button className="sb-modal-x" aria-label="Close" onClick={onClose}>
            <IconX size={15} stroke={2} />
          </button>
        </div>
        <div className="sb-modal-body">{children}</div>
        {footer ? <div className="sb-modal-foot">{footer}</div> : null}
      </div>
    </div>
  )
}
